"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationSchema = void 0;
const zod_1 = require("zod");
exports.PaginationSchema = zod_1.z.object({
    limit: zod_1.z.number().int().min(1).max(100).default(20),
    lastKey: zod_1.z.string().optional().describe('DynamoDB ExclusiveStartKey as base64'),
});
//# sourceMappingURL=pagination.schema.js.map